import logo from "../../images/vivocolourportal_logo_black.png";
import onelogin from "../../images/onelogin.png";
import Label from "@components/controls/FlintLabel";
import React, {useEffect, useState} from "react";
import styles from './LoginPage.module.scss'
import {AuthenticationResponse, LoginModel} from "@utils/auth/auth.models";
import axios from "axios";
import {ApiUrl_Login_Login} from "@utils/Endpoints";
import {ApiResponseDto, VivoRootModel} from "@utils/Models";
import {JwtUtils} from "@utils/auth/JwtUtils";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import AuthForm from "@utils/auth/AuthForm";
import FlintLoadingWrapper from "@components/page_components/common/loading/FlintLoadingWrapper";
import {useFlintNotificationContext} from "@components/page_components/common/notifications/FlintNotificationContext";
import {usePiwikContext} from "@utils/tracking/PiwikContext";
import {handleCallback, login, loginSilent} from "@utils/onelogin/OneLoginHelper";
import {useTranslation} from "react-i18next";
import FlintButton from "@components/controls/FlintButton";
import {User} from "oidc-client-ts";
import {VivoPortal} from "@utils/AppConstants";
import getClaims = JwtUtils.getClaims;
import EnumMemberGroupAliases = VivoPortal.EnumMemberGroupAliases;
import useAuthenticationHelper from "@utils/auth/AuthenticationHelper";
import LanguageSelector from "@components/page_components/common/LanguageSelector";
import * as icons from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PreloaderComponent from "@components/layout/PreloaderComponent";
import logout = JwtUtils.logout;

export default function LoginPage() {
    const {} = useLoginPage();
    // const {t} = useTranslation();

    return (
        <PreloaderComponent loadingText={"Trying to sign in"} isLoading={true}/>
        // <div className="container">
        //     <div className={styles.mainLogo}>
        //         <img src={logo} alt="Vivo ColourPortal logo"/>
        //     </div>
        //     <div className={`${styles.loginForm} mt-5`}>
        //         <div className="row">
        //             <div className="col-12">
        //                 <div className={"card"}>
        //                     <div className="card-header justify-content-between align-items-center">
        //                         <label className={"h5 m-0"}>{t("LOGIN_PageHeaderText")}</label>
        //                         <LanguageSelector/>
        //                     </div>
        //                     <div>
        //                         <div className={"card-body"}>
        //                             <div className={"text-center mb-3"}>
        //                                 <FontAwesomeIcon icon={icons.faHandPointRight} size={"2xl"} className={styles.oneLoginPointer}/>
        //                                 <FlintButton disabled={state.isLoading.get}
        //                                              onClick={handlers.handleOneLoginUser}
        //                                              className={styles.oneLoginButton}
        //                                              themeColor={"dark"}>
        //                                     <img className={styles.oneLoginLogo} src={onelogin} alt="Login to your account using oneLogin"/>
        //                                 </FlintButton>
        //                                 <div className={"pt-3 fst-italic"}>{t("LOGIN_OrUseLegacyWayText")}</div>
        //                             </div>
        //                             <FlintLoadingWrapper showLoading={state.isLoading.get}>
        //                                 <AuthForm model={{Username: '', Password: '', RememberMe: false}}
        //                                           onSubmit={async v => handlers.handleLoginUser(v)}/>
        //                             </FlintLoadingWrapper>
        //                            
        //                             <div className={"row gy-4"}>
        //                                 <div className="col-12">
        //                                     <div className={"form-group text-center d-flex justify-content-end gap-2"}>
        //                                         <Label>{t("LOGIN_RegisterButtonLabel")}</Label><a className={"text-600 ms-1"}
        //                                                                                 href="https://flintlink.com/register">{t("LOGIN_RegisterButtonText")}</a>
        //                                     </div>
        //                                     <hr/>
        //                                     <div className={"form-group text-center"}>
        //                         <span className="form-text text-center text-muted">{t("LOGIN_BottomAgreementPrefix")} <a
        //                             href="https://flintgrp.com/en/privacy-statement/">{t("REGISTER_PRIVACY_POLICY")}</a> {t("COMMON_And")} <a
        //                             href="https://flintgrp.com/en/cookie-information/">{t("LOGIN_COOKIE_POLICY")}</a></span>
        //                                     </div>
        //                                 </div>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

function useLoginPage() {
    const {rootModel, isCurrentUserInRole, VerifyTokensAsync} = useAuthenticationContext();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {update} = useAuthenticationContext();
    const {showNotification: showNotification} = useFlintNotificationContext();
    const navigate = useNavigate();
    const location = useLocation();
    const {trackers, utils, events} = usePiwikContext();
    // parse the query string
    const {search} = useLocation();
    const params = new URLSearchParams(search);
    const raw = params.get("return_url");
    // fallback to "/" if missing
    const returnTo = raw ? decodeURIComponent(raw) : "/";
    const {validation} = useAuthenticationHelper();
    /** if root model exists, redirecting to another page because the user is logged in */
    useEffect(() => {
        if (!rootModel) {
            return;
        }
        if (isCurrentUserInRole(EnumMemberGroupAliases.User)) {
            navigate('/', {replace: true});
        }
    }, [rootModel])

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const hasCode = query.has("code");
        if (!hasCode)
            return;
        setIsLoading(true);
        handleCallback()
            .then((user: User) => {
                VerifyTokensAsync(true).then((model) => {
                    if (model) {
                        trackUserLogin(model);
                    }
                    navigate(returnTo, {replace: true});
                });
            })
            .catch((error) => {
                console.error(error);
                navigate('/login', {replace: true});
            })
            .finally(() => {

            })
    }, [navigate, returnTo]);

    function trackUserLogin(rootModel: VivoRootModel) {
        utils.updateUserData(rootModel);
        trackers.trackUserData();
        events.triggerLoginEvent(true, rootModel.CurrentUserProfile.Id, rootModel.CurrentUserProfile.UserName);
        //trackers.trackVirtualPageView();

    }

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const hasCode = query.has("code");
        if (hasCode)
            return;
        // if user is authenticated we exit the method
        if (rootModel != null)
            return;
        const autologin = params.get("autologin");
        if (autologin == "onelogin") {
            handleOneLoginUser().then((response) => {
            })
        } else {
            // navigate(process.env.REACT_APP_UNLOGGED_USER_REDIRECT!.toString(), {replace: true});
            window.location.replace(process.env.REACT_APP_UNLOGGED_USER_REDIRECT!);
        }
    }, [returnTo]);

    async function handleOneLoginUser() {
        // debugger;
        // if (rootModel?.CurrentUserProfile != null)
        //     await logout()
        setIsLoading(true);
        //await login(location.pathname);
        await login();
    }

    async function handleLoginUser(model: LoginModel) {
        setIsLoading(true);
        try {
            const response = await axios.post<ApiResponseDto<AuthenticationResponse>>(`${ApiUrl_Login_Login}`, model);
            if (response.status === 200) {
                let data = response.data;
                if (data.ErrorMessages.length) {
                    showNotification(data.ErrorMessages[0]);
                    return;
                }
                JwtUtils.saveToken(data.Result);
                update(getClaims(), data.Result.RootModel);
                trackUserLogin(data.Result.RootModel);
                if (location.pathname.includes("/login")) {
                    navigate('/');
                }
                return Promise.resolve(data.Result);
            }
        } catch (e) {
            showNotification(e?.toString() + "");
        } finally {
            setIsLoading(false);
        }
    }

    return {
        state: {
            isLoading: {get: isLoading},
        },
        handlers: {
            handleLoginUser,
            handleOneLoginUser
        }
    }
}

interface LocationState {
    from?: string;
}